import React, { useContext } from "react";
import { View } from "@/styles/reactnative";
import AccountDeposit from "./AccountDeposit";
// import AccountConvert from './AccountConvert'
import AccountTransfer from "./AccountTransfer";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useMyProfile } from "@app/hooks/user/myprofile";

const DerivativesAccountBtns = () => {
  const { textw, gray } = useContext(ThemeContext).theme.COLORS;
  const { data: myinfo } = useMyProfile();
  
  // KYC 인증 상태 확인 (level 1 이상이면 인증됨)
  const isKYCVerified = myinfo?.level && myinfo.level > 1 && myinfo.level !== 7;
  
  return (
    <View
      style={{
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 10,
        cursor: 'pointer'
      }}
    >
      {isKYCVerified && (
        <AccountDeposit bgColor={gray} color={textw} />
      )}
      {/* <AccountConvert bgColor={gray} color={textw} /> */}
      <AccountTransfer bgColor={gray} color={textw} />
    </View>
  );
};

export default DerivativesAccountBtns;
